<template>
  <div>
    <!-- 上方主体 企业服务 企业安全移动通讯-->
    <div
      class="container_top"
      id="topCont"
      @mouseover="barNum = 0"
      v-if="contList.picUrl">
      <!-- 轮播图 -->
      <div class="topTitCont">
        <img
          style="width: 100%; display: block"
          :src="contList.picUrl"
          alt="" />
        <div class="cont_topTil">{{ contList.menuName }}</div>
        <!-- <div class="cont_topShad">Infrastructure services</div> -->
      </div>

      <div class="tapCont">
        <div class="tapAll">
          <div class="tapTxt">
            <div
              v-for="(item, index) in contList.menuModule"
              :key="index"
              class="tapOne"
              :class="tapFlg == index ? 'colr' : ''"
              @click="tapClic(index)">
              {{ item.title }}
            </div>
            <!-- <div
            class="tapOne"
            :class="tapFlg == 2 ? 'colr' : ''"
            @click="tapClic(2)"
          >
            方案优势
          </div>
          <div
            class="tapOne"
            :class="tapFlg == 3 ? 'colr' : ''"
            @click="tapClic(3)"
          >
            服务业务
          </div> -->
          </div>
          <div class="memoryTap">
            <img
              @click="goHome('99')"
              style="margin: 0 10px; cursor: pointer"
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
              alt="" />
            <span
              style="cursor: pointer"
              @click="goHome('2', contList.parentId)"
              >{{ contList.parentName }}</span
            >
            <img
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
              alt="" />
            <span
              style="cursor: pointer"
              @click="goHome('2-1', contList.menuId)"
              >{{ contList.menuName }}</span
            >
          </div>
        </div>
        <div
          :class="
            tapHomeFlg ? 'tapHome' : tapNum == 1 ? 'tapPackUp' : 'tapPack'
          ">
          <div class="packCont">
            <div class="tapTxt">
              <div
                v-for="(item, index) in contList.menuModule"
                :key="index"
                class="tapOne"
                :class="tapFlg == index ? 'colr' : ''"
                @click="tapClic(index)">
                {{ item.title }}
              </div>
              <!-- <div
            class="tapOne"
            :class="tapFlg == 1 ? 'colr' : ''"
            @click="tapClic(1)"
          >
            方案优势
          </div>
          <div
            class="tapOne"
            :class="tapFlg == 2 ? 'colr' : ''"
            @click="tapClic(2)"
          >
            服务业务
          </div> -->
            </div>
            <div class="memoryTap">
              <img
                @click="goHome('99')"
                style="margin: 0 10px; cursor: pointer"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
                alt="" />
              <span
                style="cursor: pointer"
                @click="goHome('2', contList.parentId)"
                >{{ contList.parentName }}</span
              >
              <img
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
                alt="" />
              <span
                style="cursor: pointer"
                @click="goHome('2-1', contList.menuId)"
                >{{ contList.menuName }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 方案介绍 -->
      <div
        class="publicCloud"
        id="advantage01"
        ref="textCont"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[0].title }}</div>
        <!-- <div class="publ_compe_fy">introduce</div> -->
        <div class="publ_compe_txt">
          {{ contList.menuModule[0].content }}
        </div>
        <!-- <div class="publCont">
        <div class="publ_img">
          <div class="img_Cont">
            <img src="@/assets/enterprise/Slice109.png" alt="" />
            <div class="img_Cont_Tit">公有云服务</div>
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div>
      </div> -->
      </div>

      <!-- 方案优势 -->
      <div
        class="publicCloud"
        id="advantage02"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[1].title }}</div>
        <!-- <div class="publ_compe_fy">advantage</div> -->
        <!-- <div class="publ_compe_txt">
        对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新
      </div> -->
        <div class="publCont">
          <div
            class="publ_img"
            v-for="(item, index) in contList.menuModule[1].detailsList"
            :key="index">
            <div class="img_Cont">
              <img
                :src="item.imgUrl"
                alt="" />
            </div>
            <div class="publ_Tit">{{ item.contentTitle }}</div>
            <div class="publ_Txt">
              {{ item.content }}
            </div>
          </div>
          <!-- <div class="publ_img">
          <div class="img_Cont">
            <img
              src="https://oss.jingshucloud.com/gw-bucket/e19338ca-4e5d-4105-9fcd-9c3eab19d576.png"
              alt=""
            />
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div>
        <div class="publ_img">
          <div class="img_Cont">
            <img
              src="https://oss.jingshucloud.com/gw-bucket/82d3e669-2042-426a-8495-3c245ffdc5fc.png"
              alt=""
            />
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div>
        <div class="publ_img">
          <div class="img_Cont">
            <img
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/e6asu83d3s7jncnofa3y.png"
              alt=""
            />
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div> -->
        </div>
      </div>

      <!-- 服务业务 -->
      <div
        class="publicCloud"
        id="advantage03"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[2].title }}</div>
        <!-- <div class="publ_compe_fy">business</div> -->
        <!-- <div class="publ_compe_txt">
        对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新
      </div> -->
        <div class="publCont">
          <div
            class="publTct"
            @click="
              goPublic('2-1-1', contList.menuModule[2].detailsList[0].detailsId)
            ">
            <div class="publ_img">
              <div class="img_Cont">
                <img
                  :src="contList.menuModule[2].detailsList[0].imgUrl"
                  alt="" />
                <div class="img_Cont_Tit">
                  {{ contList.menuModule[2].detailsList[0].title }}
                </div>
                <div class="knowMore">
                  了解更多<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <div class="publ_Tit">
              {{ contList.menuModule[2].detailsList[0].contentTitle }}
            </div>
            <div
              class="publ_Txt"
              style="width: 88%">
              {{ contList.menuModule[2].detailsList[0].content }}
            </div>
          </div>

          <div
            class="publTct"
            @click="
              goPublic('2-1-2', contList.menuModule[2].detailsList[1].detailsId)
            ">
            <div class="publ_img">
              <div class="img_Cont">
                <img
                  :src="contList.menuModule[2].detailsList[1].imgUrl"
                  alt="" />
                <div class="img_Cont_Tit">
                  {{ contList.menuModule[2].detailsList[1].title }}
                </div>
                <div class="knowMore">
                  了解更多<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <div class="publ_Tit">
              {{ contList.menuModule[2].detailsList[1].contentTitle }}
            </div>
            <div
              class="publ_Txt"
              style="width: 88%">
              {{ contList.menuModule[2].detailsList[1].content }}
            </div>
          </div>
        </div>
      </div>

      <div class="botConsult">
        <div @click="goinquiyForm">项目需求咨询</div>
      </div>
    </div>
    <div id="mobile">
      <enterpriseMobileSecurity
        :navBar="navBar"
        :contList="contList" />
    </div>
  </div>
</template>

<script>
import enterpriseMobileSecurity from '@/views/mobile/enterpriseService/enterpriseMobileSecurity.vue';
import { getCategoryInfo } from '@/api/index';
export default {
  props: { switchNum: String },
  components: { enterpriseMobileSecurity },
  data() {
    return {
      swiperOption: {
        // 变手
        grabCursor: true,
        // 衔接滑动
        loop: true,
        // 自动滑动
        autoplay: {
          delay: 5000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false,
        },
        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 'auto',
        //slider容器相互之间距离
        spaceBetween: 20,

        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        centeredSlides: true,

        // 设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,

        // 丝滑滑动
        freeMode: true,
        freeModeFluid: true,
        momentumRatio: 5,
      },
      navBar: [
        {
          icon: 'icon-home',
          path: '/enterpriseHome',
          isRutern: false,
          name: '企业服务',
          params: {},
          query: {},
        },
        {
          icon: 'icon-right-1-copy',
          path: '',
          isRutern: false,
          name: '企业安全移动通讯',
          params: {},
          query: {},
        },
      ],
      tapHomeFlg: false,
      tapNum: 0,
      textLeftFlg: false,
      textRightFlg: false,
      tapFlg: '0',
      contList: {},
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum",curVal, oldVal);

      if (curVal == 2) {
        document
          .getElementById('topCont')
          .scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    if (this.switchNum == 2) {
      document.getElementById('topCont').scrollIntoView({ behavior: 'smooth' });
      this.textLeftFlg = true;
      this.textRightFlg = true;
    }
    console.log(this.switchNum, this.textLeftFlg);
    if (this.$route.params.id) {
      localStorage.setItem('menuId', this.$route.params.id);
    }

    if (this.getID(this.$route.name, this.$store.state.treeList)) {
      localStorage.setItem(
        'menuId',
        this.getID(this.$route.name, this.$store.state.treeList).id
      );
    }
    this.flgId = localStorage.getItem('menuId');
    console.log(localStorage.getItem('menuId'), '查看id');
    if (this.flgId) {
      getCategoryInfo(this.flgId).then((res) => {
        this.contList = res.data.data;
      });
    }
  },
  methods: {
    // 回调函数
    getID(name, list) {
      let _this = this;
      for (let item of list || []) {
        if (item.routingPath == name) return item;
        const sum = _this.getID(name, item.children);
        if (sum) return sum;
      }
    },
    goinquiyForm() {
      this.$router.push({
        name: 'InquiryForm',
        params: {},
      });
    },
    tapClic(row) {
      this.tapFlg = row;
      if (row == 0) {
        document
          .getElementById('advantage01')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 1) {
        document
          .getElementById('advantage02')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 2) {
        document
          .getElementById('advantage03')
          .scrollIntoView({ behavior: 'smooth' });
      }
    },

    goHome(row, id) {
      this.$emit('switchflg', '0', row);
      if (row == '99') {
        this.$router.push({
          name: 'myHome',
          params: { id: id },
        });

        // this.$store.commit('changeTabCheck',{idNum:row,sumName:'myHome'});
      }
      if (row == '2') {
        this.$router.push({
          name: 'enterpriseHome',
          params: { id: id },
        });
        this.$store.commit('changeTabCheck', {
          idNum: row,
          sumName: '',
        });
        this.$store.state.enterp_somFlg = '';
      }
      // if (row == "2-1") {
      //   this.$router.push({
      //     name: "enterpriseHome/enterpriseService",
      //     params: {},
      //   });
      // }
    },
    // // 回调函数
    // getID(name, list) {
    //   let _this = this;
    //   for (let item of list || []) {
    //     if (item.label == name) return item;
    //     const sum = _this.getID(name, item.children);
    //     if (sum) return sum;
    //   }
    // },
    goPublic(row, id) {
      if (row == '2-1-1') {
        this.$router.push({
          name: 'enterpriseHome/enterpriseMobileSecurity/enterprisecublicCloud',
          params: {
            id: id,
          },
        });
      }
      if (row == '2-1-2') {
        this.$router.push({
          name: 'enterpriseHome/enterpriseMobileSecurity/enterprisePrivateCloud',
          params: {
            id: id, // this.getID("私有云服务", this.$store.state.treeList).id
          },
        });
      }

      this.$store.commit('changeTabCheck', {
        idNum: row,
        sumName: '',
      });
      this.$store.state.enterp_somFlg = row.substring(0, 3);
    },

    handleScroll() {
      if (this.$refs.textCont && this.$refs.textCont.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.textCont.offsetTop,
        //   this.switchNum
        // );
        // if (this.switchNum == 0) {
        //   this.textLeftFlg = false;
        //   this.textRightFlg = false;
        // }

        if (window.scrollY > 650) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        // if (window.scrollY > 80) {
        //   this.textLeftFlg = true;
        //   this.textRightFlg = true;
        // }

        this.$emit('switchflg', '0');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container_top {
  width: 100%;
  .topTitCont {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    //left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    opacity: 0.8;
    position: absolute;
    bottom: 46%;
    //left: 13%;
    font-size: 18px;
    color: white;
  }
}

// 文字菜单栏动画
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapOne {
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: '';
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  //tap动画
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .packCont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 1200px;
  }
  .tapHome {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
  .tapTxt {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-left: -20px;
  }
  .memoryTap {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .memoryTap img {
    width: 20px;
  }
}

// 方案介绍
.publicCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding: 60px 10px;
  margin-top: 100px;
  .publ_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  // .publ_compe_tit::before {
  //   content: "";
  //   height: 1px;
  //   background: #151a23;
  //   position: absolute;
  //   top: 60px;
  //   width: 100%;
  // }
  .publ_compe_fy {
    font-size: 20px;
    color: #8a8c91;
    // margin-bottom: 60px;
    // 文字渐变
    // background: linear-gradient(to top, #ffffff 0%, #ffffff 25%, #f4ca80 100%);
    // background-clip: text;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .publ_compe_txt {
    // width: 80%;
    // margin: 60px 0;
    margin-top: 60px;
    // text-align: center;

    // width: 1200px;
    width: 100%;
    max-width: 1200px;
  }

  .publCont {
    display: flex;
    justify-content: center;
    // align-items: center;
    // margin: 80px;
    // flex-wrap: wrap;
    // width: 87%;
    width: 100%;
    max-width: 1230px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .publTct {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .publ_img {
    margin: 0 15px;
    position: relative;
    // width: 22%;
  }

  .publ_img img {
    display: block;
    cursor: pointer;
    transition: ease all 0.3s;
    width: 100%;
  }
  // .publ_img::before {
  //   content: "";
  //   display: block;
  //   position: absolute; /* 设置绝对定位 */
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background-color: rgba(0, 0, 0, 0.4);
  //   z-index: 1;
  // }
  .publ_img:hover img {
    transform: scale(1.1);
  }
  // .publ_img div {
  //   margin-top: 20px;
  // }
  .img_Cont {
    position: relative;
    overflow: hidden;
  }
  .img_Cont_Tit {
    position: absolute;
    bottom: 20px;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    transition: all 0.3s ease-in-out;
    z-index: 2;
  }
  .publ_img:hover .img_Cont_Tit {
    bottom: 45px !important;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .publ_img:hover .knowMore {
    // bottom: 20px !important;
    // display: block;
    height: 40px;
    opacity: 1;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .knowMore {
    position: absolute;
    height: 0;
    // bottom: 40px;
    color: #fff;
    font-size: 16px;
    margin-left: 20px;
    transition: all 0.3s ease-in-out;
    // bottom: -65px !important;
    bottom: 0px !important;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }
  .publ_Tit {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-top: 20px;
  }
  .publ_Txt {
    text-align: justify;
  }
}

.botConsult {
  height: 100%;
  background: #fff;
  // padding: 80px;
  // height: 100px;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.botConsult div {
  color: #fff;
  cursor: pointer;
  background: #04758e;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  // border-radius: 6px;
}
</style>
<style lang="scss" scoped>
@import '@/assets/variables.scss';
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
